import { contactHeaders } from '@/components/ClientDetailEntry/clientDetailData';
import UpdateContactField from '@/components/ClientDetailEntry/UpdateContactField';
import { ConfirmDialog } from '@/components/dialogs/ConfirmDialog';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import {
	useDeleteContactMutation,
	useListContactsQuery,
	useUpdateContactMutation,
} from '@/features/contacts/contactsApi';
import { Box, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const ContactSection = ({ contact }) => {
	const { clientId } = useParams();

	const { data: contacts } = useListContactsQuery(clientId, {
		skip: !clientId,
		selectFromResult: ({ data, ...rest }) => {
			const contacts = (data ?? []).slice();
			contacts.sort(
				(a, b) =>
					(b.isMainContact ? 1 : 0) - (a.isMainContact ? 1 : 0) ||
					(a.Name ?? a.Addressee ?? '').localeCompare(b.Name ?? b.Addressee ?? ''),
			);
			return {
				...rest,
				data: contacts,
			};
		},
	});

	const { data: clientRow } = useGetClientRowQuery(clientId, {
		skip: !clientId,
	});

	const [updateContact, contactState] = useUpdateContactMutation();
	const [deleteContact, deleteContactState] = useDeleteContactMutation();

	const [dialogOpen, setDialogOpen] = useState(false);

	const handleOpenDialog = () => {
		setDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setDialogOpen(false);
	};

	const handleConfirmDialog = async () => {
		try {
			const isRemovingMainContact = contact.isMainContact;

			if (isRemovingMainContact) {
				const newMainContact = contacts.find((c) => c.Id !== contact.Id);
				if (newMainContact) {
					// Promotes another contact
					const newMainContactRes = await updateContact({
						insightId: newMainContact.Id,
						clientId: clientRow?.clientId,
						isMainContact: true,
					}).unwrap();
					console.log('Updated new main contact', newMainContactRes);
				} else {
					return;
				}
			}
			const contactRes = await deleteContact({
				insightId: contact.Id,
				clientId: clientRow?.clientId,
			}).unwrap();
			console.log('Deleted old contact', contactRes);

			handleCloseDialog();
			setTimeout(() => window.scrollTo(0, 0), 100);
		} catch (err) {
			console.error('Error removing association:', err);
		}
	};

	return (
		<>
			<Stack spacing={2} sx={{ paddingX: '0.5em' }}>
				{Object.entries(contactHeaders).map(([key, header]) => {
					return (
						<Stack key={`detail-entry-${key}`}>
							<UpdateContactField
								header={key}
								title={header}
								contact={contact}
								handleOpenDialog={handleOpenDialog}
								disabled={contactState.isLoading || deleteContactState.isLoading}
							/>
						</Stack>
					);
				})}
			</Stack>
			<ConfirmDialog
				openDialog={dialogOpen}
				handleClose={handleCloseDialog}
				handleConfirm={handleConfirmDialog}
				canBeUndone={true}
				actionName={'remove contact'}
				additionalContent={`The contact "${contact.Name}" will no longer be associated with this client.`}
			/>
		</>
	);
};
export default ContactSection;
